
export enum DownloadOfmStatus {
  PREPARING = "PREPARING",
  READY = "READY",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
}

export function normalizeDownloadStatus(raw?: string | null): DownloadOfmStatus | undefined {
  if (!raw) return;
  const up = String(raw).toUpperCase();
  if ((Object.values(DownloadOfmStatus) as string[]).includes(up)) {
    return up as DownloadOfmStatus;
  }
  return;
}

export const DownloadStatusLabelPT: Record<DownloadOfmStatus, string> = {
  [DownloadOfmStatus.PREPARING]: "Preparando",
  [DownloadOfmStatus.READY]: "Pronto",
  [DownloadOfmStatus.EXPIRED]: "Expirado",
  [DownloadOfmStatus.ERROR]: "Erro",
};

export const isReady = (s?: DownloadOfmStatus) => s === DownloadOfmStatus.READY;
export const isTerminal = (s?: DownloadOfmStatus) =>
  s === DownloadOfmStatus.READY || s === DownloadOfmStatus.EXPIRED || s === DownloadOfmStatus.ERROR;
